import Banner01 from "../images/Banners/Banner01.png";
import BannerRepositorioAcademico from "../images/Banners/BannerRepositorioAcademico.png";
import OuvidoriaBanner from "../images/Banners/BannerOuvidoria.png";
import JornaisEletronicosBanner from "../images/Banners/BannerJornaisEletronicos.png";
import PeriodicosEletronicosBanner from "../images/Banners/BannerPeriodicosEletronicos.png";
import bannerclinica from "../images/bannerclinica.png";

export const HomeBanners = [
  {
    id: 1,
    desktop: Banner01,
    mobile: "",
    alt: " ",
  },
  // {
  //  id: 1,
  // desktop: Banner03,
  // mobile: "",
  // alt: "Banner About 1",
  // link: "#about",
  // },
];

export const RepositorioAcademicoBanners = [
  {
    id: 1,
    desktop: BannerRepositorioAcademico,
    mobile: "",
    alt: " ",
  },
  // {
  //  id: 1,
  // desktop: Banner03,
  // mobile: "",
  // alt: "Banner About 1",
  // link: "#about",
  // },
];

export const OuvidoriaBanners = [
  {
    id: 1,
    desktop: OuvidoriaBanner,
    mobile: "",
    alt: " ",
  },
  // {
  //  id: 1,
  // desktop: Banner03,
  // mobile: "",
  // alt: "Banner About 1",
  // link: "#about",
  // },
];

export const JornaisBanners = [
  {
    id: 1,
    desktop: JornaisEletronicosBanner,
    mobile: "",
    alt: " ",
  },
  // {
  //  id: 1,
  // desktop: Banner03,
  // mobile: "",
  // alt: "Banner About 1",
  // link: "#about",
  // },
];
export const PeriodicosBanners = [
  {
    id: 1,
    desktop: PeriodicosEletronicosBanner,
    mobile: "",
    alt: " ",
  },
  // {
  //  id: 1,
  // desktop: Banner03,
  // mobile: "",
  // alt: "Banner About 1",
  // link: "#about",
  // },
];

export const BannerAgendamento = [
  {
    id: 1,
    desktop: bannerclinica,
  },
];
